import React, { useEffect } from 'react'
import PageLayout from 'components/layouts/PageLayout'
import SectionLayout from 'components/layouts/SectionLayout'
import SmallBanner from 'components/SmallBanner'
import ContactUsContent from './content/ContactUsContent'
import { contactUsBannerContent } from './content/banner.js'

function ContactUs() {

  useEffect(() => {
    // Change Tab Title
    document.title = "Contact Us - Insurance Enterprise"
  }, [])

  return (
    <>

      <SmallBanner content={contactUsBannerContent} />
      <PageLayout
        content={<SectionLayout content={<ContactUsContent />} />}
      />

    </>
  )
}

export default ContactUs